import { render } from "./PasswordComponent.vue?vue&type=template&id=1f2be424&scoped=true"
import script from "./PasswordComponent.vue?vue&type=script&lang=js"
export * from "./PasswordComponent.vue?vue&type=script&lang=js"

import "./PasswordComponent.vue?vue&type=style&index=0&id=1f2be424&scoped=true&lang=css"

import exportComponent from "D:\\Java Script Udemy Kurs\\VUE COURSE\\vue-form\\vue-form\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2be424"]])

export default __exports__